export default "__VITE_ASSET__CHxhdmrb__"